// Module
var code = "<div class=\"pipeline-label-form\"> <input type=\"text\" class=\"field\" ng-model=\"vm.labelName\" ng-change=\"vm.onChangeName({ name: vm.labelName })\"/> <pipeline-label-color-picker selected-color=\"vm.labelColor\" on-color-selected=\"vm.onSelectColor({ selectedColor })\"></pipeline-label-color-picker> </div> ";
// Exports
module.exports = code;